// ═══ 관세사 전송 카드 — Invoice.js에서 분리 ═══
// 임시저장 / 출력 / 관세사 전송 버튼 + 누락 서류 경고 + 강제 전송
// + 카톡 공유 (2026-04-21, 항상 노출 + 자동 임시저장)
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import { getKakaoAppKey } from '../utils/kakaoKey';

// 환경별 카카오 JS 키 — 운영(autodex.kr)=autodex 키 / 테스트(test.autodex.kr)=테스트vm 키.
// 카카오 콘솔 JS 키마다 "JS SDK 도메인"이 따로라, 도메인≠키 시 Error 4019 (test 에서 발생).
var KAKAO_APP_KEY = getKakaoAppKey((typeof window !== 'undefined' && window.location) ? window.location.hostname : '');

function InvoiceSend(props) {
  var c = props.c;
  // 공유 진행 상태. (이전 pendingShare + savedInvoiceId watcher 는 제거 —
  //  저장 실패로 pendingShare 가 누수되면 이후 '임시저장 불러오기'가 savedInvoiceId 를 set 할 때
  //  watcher 가 오발화하여 카톡 팝업이 자동으로 떴음. 이제 shareKakao 가 저장→공유를 직접 await.)
  var sharingState = useState(false);
  var sharing = sharingState[0];
  var setSharing = sharingState[1];
  // 관세사 바로전송(in-system) 진행 상태
  var sendingBrokerState = useState(false);
  var sendingBroker = sendingBrokerState[0];
  var setSendingBroker = sendingBrokerState[1];

  // Kakao SDK 초기화 (1회만)
  useEffect(function() {
    try {
      if (typeof window !== 'undefined' && window.Kakao && !window.Kakao.isInitialized()) {
        window.Kakao.init(KAKAO_APP_KEY);
      }
    } catch (e) { /* silent */ }
  }, []);

  async function performShare(invId, force) {
    if (typeof window === 'undefined' || !window.Kakao || !window.Kakao.isInitialized || !window.Kakao.isInitialized()) {
      c.showToast && c.showToast('\uCE74\uCE74\uC624 \uACF5\uC720 \uC900\uBE44 \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4', 'err');
      return false;
    }
    try {
      var r = await authFetch(API + '/invoices/' + invId + '/share-token' + (force ? '?force=1' : ''));
      var d = await r.json();
      if (d && d.success === false && Array.isArray(d.warnings) && d.warnings.length && !force) {
        if (c.setSendWarnings) c.setSendWarnings(d.warnings);
        var msg = '누락 서류가 있습니다.\n\n' + d.warnings.map(function(w) { return '- ' + w; }).join('\n') + '\n\n그래도 카톡 공유 링크를 발급할까요?';
        if (typeof window !== 'undefined' && window.confirm && window.confirm(msg)) {
          return await performShare(invId, true);
        }
        c.showToast && c.showToast('누락 서류가 있어 카톡 공유를 보류했습니다', 'err');
        return false;
      }
      if (!d || !d.success || !d.token) {
        c.showToast && c.showToast((d && (d.error || d.message)) || '\uACF5\uC720 \uB9C1\uD06C \uBC1C\uAE09 \uC2E4\uD328', 'err');
        return false;
      }
        // 서버가 첨부 유무 분기: 첨부 없으면 Excel 직접 스트리밍, 있으면 share.html 로 redirect
        // #324: apex(autodex.kr)는 정적 버킷이라 /api 없음 — API(api 오리진 + /api)로 조립
        var pageUrl = API + '/invoices/share/' + d.token + '/auto';
        // 카드 제목 — "업체명 목적지 선적방식건 진행요망" (예: "부타무역 LIBYA 컨테이너건 진행요망")
        var companyName = (c.shipCo && c.shipCo.companyName) || 'AUTODEX';
        var destParts = String(c.toPort || '').split(',').map(function(s) { return s.trim(); }).filter(Boolean).join(' ');
        var shippingLabel = c.shippingType === 'container' ? '\uCEE8\uD14C\uC774\uB108' : '\uB85C\uB85C\uC120';
        var cardTitle = companyName + (destParts ? ' ' + destParts : '') + ' ' + shippingLabel + '\uAC74 \uC9C4\uD589\uC694\uB9DD';
        var carCount = (c.cars && c.cars.length) || 0;
        var cardDesc = '\uCC28\uB7C9 ' + carCount + '\uB300 \u00B7 24\uC2DC\uAC04 \uC720\uD6A8';
        try {
          window.Kakao.Share.sendDefault({
            objectType: 'feed',
            content: {
              title: cardTitle,
              description: cardDesc,
              imageUrl: 'https://autodex.kr/autodex-og.png',
              link: { mobileWebUrl: pageUrl, webUrl: pageUrl }
            },
            buttons: [{
              title: '\uD30C\uC77C \uBAA9\uB85D \uBCF4\uAE30',
              link: { mobileWebUrl: pageUrl, webUrl: pageUrl }
            }]
          });
        } catch (e) {
          c.showToast && c.showToast('\uCE74\uCE74\uC624 \uACF5\uC720 \uC2E4\uD328: ' + (e.message || ''), 'err');
          return false;
        }
      return true;
    } catch (e) {
      c.showToast && c.showToast('\uACF5\uC720 \uB9C1\uD06C \uC694\uCCAD \uC2E4\uD328', 'err');
      return false;
    }
  }

    // 저장 → 공유 직접 흐름 (watcher 제거). 미저장이면 저장 후 invId 받아 성공 시에만 공유.
  // '임시저장 불러오기'로 savedInvoiceId 가 set 돼도 공유는 일어나지 않음 (오발화 방지).
  var shareKakao = async function() {
    if (sharing) return; // 중복 클릭 방지
    setSharing(true);
    try {
      var invId = c.savedInvoiceId;
      if (!invId) {
        if (!c.saveDraft) {
          c.showToast && c.showToast('\uC800\uC7A5 \uD568\uC218\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4', 'err');
          return;
        }
        // saveDraft 는 성공 시 invId, 실패 시 null 반환 (실패 사유 토스트는 saveDraft 내부 표시)
        invId = await c.saveDraft();
      }
      if (invId) await performShare(invId, false);
    } catch (e) {
      c.showToast && c.showToast('\uC800\uC7A5 \uC624\uB958: ' + (e.message || ''), 'err');
    } finally {
      setSharing(false);
    }
  };

  var shareBusy = sharing || c.savingDraft;

  // 관세사 시스템 내 직접 전송 (카톡/이메일 0) — POST /invoices/:id/send-broker
  function performSendBroker(invId) {
    authFetch(API + '/invoices/' + invId + '/send-broker', { method: 'POST' })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d && d.success) {
          if (d.queued > 0) c.showToast && c.showToast('\u2705 \uAD00\uC138\uC0AC\uC5D0\uAC8C ' + d.queued + '\uB300 \uC758\uB8B0 \uC804\uC1A1', '');
          else c.showToast && c.showToast('\uC804\uC1A1\uB428 \u2014 \uC2E0\uADDC \uC758\uB8B0 0\uAC74 (\uAD00\uC138\uC0AC \uB9E4\uD551/\uCC28\uB7C9 \uC0C1\uD0DC \uD655\uC778)', '');
        } else {
          c.showToast && c.showToast((d && d.error) || '\uAD00\uC138\uC0AC \uC804\uC1A1 \uC2E4\uD328', 'err');
        }
      })
      .catch(function() { c.showToast && c.showToast('\uAD00\uC138\uC0AC \uC804\uC1A1 \uC694\uCCAD \uC2E4\uD328', 'err'); });
  }

  // 저장 → 바로전송 (미저장이면 saveDraft await 후 invId 성공 시에만). '불러오기' 오발화 없음.
  var sendBroker = async function() {
    if (sendingBroker) return;
    setSendingBroker(true);
    try {
      var invId = c.savedInvoiceId;
      if (!invId) {
        if (!c.saveDraft) { c.showToast && c.showToast('\uC800\uC7A5 \uD568\uC218\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4', 'err'); return; }
        invId = await c.saveDraft();
      }
      if (invId) performSendBroker(invId);
    } catch (e) {
      c.showToast && c.showToast('\uC804\uC1A1 \uC624\uB958: ' + (e.message || ''), 'err');
    } finally {
      setSendingBroker(false);
    }
  };

  var brokerBusy = sendingBroker || c.savingDraft;

  return (
    <div className="card" style={{padding:16}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
        <h3 style={{fontSize:14,margin:0}}>관세사 전송</h3>
        <span style={{padding:'3px 10px',borderRadius:12,fontSize:11,fontWeight:700,background:c.invoiceStatus==='sent'?'#dcfce7':c.invoiceStatus==='ready'?'#fff7ed':'#f1f5f9',color:c.invoiceStatus==='sent'?'#166534':c.invoiceStatus==='ready'?'#c2410c':'#64748b',border:'1px solid '+(c.invoiceStatus==='sent'?'#86efac':c.invoiceStatus==='ready'?'#fdba74':'#e2e8f0')}}>{c.invoiceStatus==='sent'?'✅ 발송완료':c.invoiceStatus==='ready'?'⚡ 발송대기':'임시저장'}</span>
      </div>
      <label style={c.ls}>관세사 이메일</label>
      <input style={c.is} value={c.toEmail} onChange={function(e){c.setToEmail(e.target.value)}} placeholder="customs@example.com" type="email"/>
      {/* 줄 1: 임시저장 / 출력 / 관세사 전송 */}
      <div style={{display:'flex',gap:8,marginTop:12}}>
        <button onClick={function(){c.setConfirmAction({type:'draft',title:'임시저장',msg:'인보이스를 임시저장하시겠습니까?',fn:c.saveDraft})}} disabled={c.savingDraft} style={{padding:'11px 16px',background:c.savingDraft?'#94a3b8':'#f8fafc',color:'#475569',border:'1px solid #d0d5dd',borderRadius:8,fontSize:13,fontWeight:700,cursor:c.savingDraft?'default':'pointer'}}>{c.savingDraft?'저장중...':'임시저장'}</button>
        <button onClick={function(){c.setConfirmAction({type:'print',title:'인보이스 출력',msg:'인보이스를 출력하시겠습니까?',fn:c.printInvoice})}} style={{flex:1,padding:'11px',background:'#475569',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:700,cursor:'pointer'}}>출력</button>
        <button onClick={function(){c.setConfirmAction({type:'send',title:'관세사 전송',msg:c.toEmail+'로 인보이스를 전송하시겠습니까?',fn:c.sendToCustoms})}} disabled={c.sending} style={{flex:1,padding:'11px',background:c.sending?'#94a3b8':c.sent?'#16a34a':'#2563eb',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:700,cursor:c.sending?'default':'pointer'}}>
          {c.sending?'전송 중...':c.sent?'재전송':'관세사 전송'}
        </button>
      </div>
      {/* 줄 2: 카톡 공유 (항상 노출, 미저장 시 자동 임시저장) */}
      <div style={{display:'flex',gap:8,marginTop:8}}>
        <button onClick={shareKakao} disabled={shareBusy} style={{flex:1,padding:'11px',background:shareBusy?'#fef3c7':'#FEE500',color:'#3C1E1E',border:'1px solid #FADA0A',borderRadius:8,fontSize:13,fontWeight:700,cursor:shareBusy?'default':'pointer',opacity:shareBusy?0.7:1}}>
          {shareBusy?'저장 중...':'💬 카톡 공유'}
        </button>
        <button onClick={sendBroker} disabled={brokerBusy} title="\uB4F1\uB85D\uB41C \uAD00\uC138\uC0AC\uC5D0\uAC8C \uC2DC\uC2A4\uD15C \uB0B4\uB85C \uBC14\uB85C \uC804\uC1A1 (\uCE74\uD1A1/\uC774\uBA54\uC77C \uC5C6\uC74C)" style={{flex:1,padding:'11px',background:brokerBusy?'#94a3b8':'#1B3A5C',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:700,cursor:brokerBusy?'default':'pointer'}}>
          {brokerBusy?'\uC804\uC1A1 \uC911...':'\uD83C\uDFDB\uFE0F \uAD00\uC138\uC0AC \uBC14\uB85C\uC804\uC1A1'}
        </button>
      </div>
      {c.sendWarnings.length>0&&<div style={{background:'#fef2f2',padding:10,borderRadius:8,marginTop:10,fontSize:11,color:'#dc2626'}}>
        <b>누락 서류:</b><br/>{c.sendWarnings.map(function(w,i){return <div key={i}>- {w}</div>})}
        <button className="btn btn-sm" style={{marginTop:8,background:'#dc2626',color:'#fff',border:'none'}} onClick={function(){c.forceSend()}}>경고 무시하고 강제 전송</button>
      </div>}
    </div>
  );
}

export default InvoiceSend;
